import * as React from "react";
const SvgStatusSuccessIcon = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", "data-icon": "statusSuccess", role: "img", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.444 3.685a10 10 0 1 1 11.112 16.63A10 10 0 0 1 6.444 3.685m9.72 5.14a1 1 0 0 0-.739-.326 1 1 0 0 0-.705.291l-4.29 4.3-1.65-1.65a1.001 1.001 0 1 0-1.41 1.41l2.35 2.36a1 1 0 0 0 1.41 0l5-5a1 1 0 0 0 .034-1.384Z", clipRule: "evenodd" }));
export default SvgStatusSuccessIcon;
